import template from './stats.tpl.html';
import './stats-controller';
/**
 * @ngdoc directive
 * @name festzelt-os.seatplans.directive:stats
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.seatplans">
 <file name="index.html">
 <seatplan-group></seatplan-group>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.statistics')
    .directive('stats', stats);

function stats() {
    return {
        restrict: 'EA',
        scope: {},
        templateUrl: template,
        replace: false,
        controllerAs: 'vm',
        controller: 'StatisticsStatsCtrl',
        bindToController: {
            group: '@',
            source: '@',
            type: '@',
            params: '=',
            refreshIndex: '<',
            hideLegend: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/pages/statistics/directives/stats/stats-directive.js